var map = {
	"./award0.jpg": "rKod",
	"./award1.jpg": "yyHq",
	"./award10.jpg": "gXgY",
	"./award2.jpg": "7sdt",
	"./award3.jpg": "RChl",
	"./award4.jpg": "oFqA",
	"./award5.jpg": "RzKm",
	"./award6.jpg": "cEtW",
	"./award7.jpg": "Y7mV",
	"./award8.jpg": "pZPn",
	"./award9.jpg": "AOVy",
	"./backGround2.jpg": "WTOI",
	"./backGround3.jpg": "2ikY",
	"./button1.jpg": "Z1Vm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53WL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 53WL
// module chunks = 1